<template>
  <div class="container-fluid">
    <div class="row container-showcase align-start justify-space-between">
      <v-col
        cols="12"
        class="wow fadeInLeftBig col-lg-7 col-xl-7 player"
        style="position: relative"
      >
        <player :poster-url="ctnShowcase.url_poster" :video-plr="video">
          <template v-slot:ads>
            <!--              icon live-->
            <div style="position: absolute; top: 14px; left: 10px">
              <svg
                width="106"
                height="25"
                viewBox="0 0 106 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="34.7444"
                  cy="11.9709"
                  r="9.15693"
                  transform="rotate(1.60551 34.7444 11.9709)"
                  fill="#FF0000"
                />
                <path
                  d="M49.9727 5.8999C52.3323 7.80267 55.6792 13.0883 50.1898 19.0086"
                  stroke="#FF0000"
                />
                <path
                  d="M53.9023 3.35791C57.2169 6.03071 61.9182 13.4553 54.2074 21.7715"
                  stroke="#FF0000"
                />
                <path
                  d="M57.4648 1.1001C61.5807 4.4191 67.4187 13.6388 57.8436 23.9656"
                  stroke="#FF0000"
                />
                <path
                  d="M18.9609 18.417C16.6013 16.5142 13.2544 11.2286 18.7438 5.30828"
                  stroke="#FF0000"
                />
                <path
                  d="M15.9727 20.9854C12.6581 18.3126 7.95678 10.8879 15.6676 2.57173"
                  stroke="#FF0000"
                />
                <path
                  d="M12.4062 23.2432C8.29036 19.9242 2.45237 10.7045 12.0275 0.377677"
                  stroke="#FF0000"
                />
                <rect
                  x="68.877"
                  y="4.36768"
                  width="37.124"
                  height="14.9799"
                  rx="7.48993"
                  fill="#FF0000"
                />
                <path
                  d="M78.3711 15.4395V8.33447H79.6582V14.3606H82.7875V15.4395H78.3711Z"
                  fill="white"
                />
                <path
                  d="M85.1917 8.33447V15.4395H83.9046V8.33447H85.1917Z"
                  fill="white"
                />
                <path
                  d="M87.536 8.33447L89.3852 13.9269H89.458L91.3037 8.33447H92.7191L90.2143 15.4395H88.6254L86.124 8.33447H87.536Z"
                  fill="white"
                />
                <path
                  d="M93.655 15.4395V8.33447H98.276V9.41342H94.9421V11.3423H98.0367V12.4213H94.9421V14.3606H98.3038V15.4395H93.655Z"
                  fill="white"
                />
              </svg>
            </div>
            <div v-for="(shop, idxShop) in shops" :key="idxShop">
              <div
                class="movingElement"
                :style="{
                  left: shop.x + 'px',
                  top: shop.y + 'px',
                  width: shop.width + 'px',
                  height: shop.height + 'px',
                  border: showRecBoxProd ? '1px solid red' : '',
                }"
                @mouseover="showShopping(shop)"
                @mouseleave="hideShopping()"
              >
                <div @click="onclickBuyNow(shop)" class="buy-now show"></div>
              </div>
              <div
                v-show="
                  showInfoProd &&
                  !slotPanel &&
                  Math.round(new Date().getTime() / 1000) - shop.timeStart <
                    expireLabel
                "
                :id="shop.idStyle"
              >
                <!--                text info-->
                <div
                  class="fixedElement"
                  style="
                    position: absolute;
                    color: white;
                    pointer-events: all;
                    display: block;
                  "
                  :style="{
                    left: shop.textData.x + 'px',
                    top: shop.textData.y + 'px',
                    height: heightText + 'px',
                  }"
                >
                  <div id="wrapperDiv" class="wow wrapper">
                    <div
                      class="box-line"
                      style="
                        border-color: rgb(250, 250, 250);
                        visibility: inherit;
                        opacity: 1;
                        transform: matrix(1, 0, 0, 1, 0, 0);
                        transform-origin: left 50% 0;
                      "
                    ></div>
                    <div
                      class="mainTag"
                      style="
                        color: rgb(34, 34, 34);
                        visibility: inherit;
                        opacity: 1;
                      "
                    >
                      <div class="mainInfo">
                        <h2 style="color: white">{{ shop.name }}</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <!--                lineAnimate-->
                <div
                  class="lineElement"
                  :style="{
                    left: shop.lineData.x + 'px',
                    top: shop.lineData.y + 'px',
                    height: '1px',
                    width: shop.lineData.width + 'px',
                    transform: 'rotate(' + shop.lineData.rotate + 'deg)',
                  }"
                >
                  <div class="animate-line"></div>
                </div>
              </div>
              <!--        top left-->
            </div>
            <!--            panel in player-->
            <div
              v-if="!slotPanel && showShopInfo"
              class="wow zoomIn panel-in-player d-flex align-center justify-center"
              style="position: absolute"
            >
              <v-col
                sm="12"
                xs="12"
                md="12"
                lg="10"
                xl="10"
                style="position: relative"
                class="container-prod"
              >
                <product :product="showShopInfo" />
              </v-col>
              <div style="position: absolute; top: 6px; right: 8px">
                <v-icon @click="showShopInfo = null">{{ mdiClose }}</v-icon>
              </div>
            </div>
          </template>
        </player>
        <content-same-showcase
          :title="ctnShowcase.title"
          :type-show-case="Number(ctnShowcase.type_showcase)"
          :showcase-id="ctnShowcase.showcase_id"
          @selectContent="handleChangeContent"
        />
      </v-col>
      <!--      panel product-->
      <v-col
        cols="12"
        class="col-xl-5 col-lg-5 mt-lg-0 mt-md-12 mt-sm-12 mt-xs-12"
      >
        <div class="title-demo">
          <h5 v-html="`Demo ${$t('live_title')}`"></h5>
          <span>
            {{ $t("live_des") }}
          </span>
        </div>
        <transition name="slide-fade">
          <div
            v-if="
              this.$vuetify.breakpoint.name === 'xl' ||
              this.$vuetify.breakpoint.name === 'lg'
            "
            class="wow fadeInRight"
            style="position: relative"
          >
            <v-card
              width="100%"
              min-height="300px"
              height="auto"
              style="z-index: 2"
            >
              <v-card-text>
                <div
                  class="pa-xl-6 pa-lg-4"
                  style="max-height: 500px; overflow-y: auto"
                >
                  <div
                    v-if="showShopInfo"
                    class="wow fadeInUp mb-2"
                    :id="`btn-${showShopInfo.id}`"
                  >
                    <product :product="showShopInfo" />
                  </div>
                </div>
              </v-card-text>
            </v-card>
            <div class="close-panel" v-if="showPrPanel" role="user">
              <div class="title-panel-close justify-space-between">
                <small class="mr-4">Product panel</small>
              </div>
            </div>
          </div>
        </transition>
      </v-col>
    </div>
  </div>
</template>

<script>
import { playerShowcase } from "../../minxin/player-showcase";
import _ from "lodash";
import { io } from "socket.io-client";
import Hls from "hls.js";
import ContentSameShowcase from "./components/ContentSameShowcase";
import Player from "./components/Player";
import Product from "./components/Product";
import { mdiClose } from "@mdi/js";

export default {
  name: "Live",
  components: { Product, Player, ContentSameShowcase },
  mixins: [playerShowcase],
  created() {
    switch (this.$vuetify.breakpoint.name) {
      case "lg":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      case "xl":
        this.showPrPanel = true;
        this.slotPanel = true;
        break;
      default:
        this.showPrPanel = false;
        this.slotPanel = false;
        break;
    }
  },
  data() {
    return {
      mdiClose: mdiClose,
      showShopInfo: null,
      firstTime: null,
      firstClearBoxes: true,
      firstPlay: 0,
      delayHls: 1,
      currentSegment: null,
      countChange: 0,
      socketMng: null,
      showPanelAdmin: false,
      dataAdmin: null,
      oldSec: null,
      mlSec: 0,
      numOld: 0,
    };
  },
  watch: {
    showShopInfo(val) {
      if (val === null) {
        this.plyr.play();
      }
    },
  },
  methods: {
    getCurrentMetaWithPos() {
      /*
      So sanh và get meta data tại thời điểm  hiện tại video display
      */
      let currentMsg = [];
      if (this.showcaseCr.data.length === 0 || !this.firstTime) return null;
      let message = this.showcaseCr.data[this.showcaseCr.data.length - 1];
      const markCurr = new Date(
        this.firstTime.getTime() + this.timePlay * 1000
      );
      while (
        message &&
        new Date(message.timestamp - message.process_time) - markCurr <= 0
      ) {
        currentMsg.push(message);
        message = this.showcaseCr.data.pop();
        // if (currentMsg.length >= 5) {
        //   break;
        // }
      }
      // console.log(`time: ${this.timePlay} | ${message.length}`);
      if (this.firstClearBoxes === true) {
        this.firstClearBoxes = false;
        return [];
      }
      return this._groupMsg(currentMsg);
    },
    async _fetchMessages() {
      console.log("start fetch message");
      const response = await fetch(
        `${process.env.VUE_APP_API_BASE_URL}/api/live/messages`
      );
      // Storing response
      let data = await response.json();
      const messages = data.result.messages;
      for (const msg of messages) {
        const itemMeta = {
          pred_boxes: msg.detections,
          process_time: msg.process_time,
          timestamp: msg.timestamp,
        };
        this.showcaseCr.data.push(itemMeta);
      }
    },
    handleMsg(data) {
      const itemMeta = {
        pred_boxes: data.detections,
        process_time: data.process_time,
        timestamp: data.timestamp,
      };
      let dateNew = new Date(data.timestamp);
      const second = dateNew.getSeconds();
      if (this.oldSec === null) {
        this.oldSec = second;
      }
      if (this.oldSec === second) {
        this.numOld += 1;
        this.mlSec = dateNew.getMilliseconds();
      } else {
        this.oldSec = null;
        this.numOld = 0;
      }
      this.showcaseCr.data.unshift(itemMeta);
    },
    onclickBuyNow(shop) {
      this.socketMng.emit("click", {
        id: shop.id,
      });
      this.showShopping(shop, true);
    },
    showShopping(shop, force = false) {
      shop.timeStart = Math.round(new Date().getTime() / 1000);
      if (!force) {
        this.socketMng.emit("hover", {
          id: shop.id,
        });
      }

      if (
        !force &&
        (this.$vuetify.breakpoint.name === "xl" ||
          this.$vuetify.breakpoint.name === "lg")
      ) {
        return;
      }
      shop.timeStart = Math.round(new Date().getTime() / 1000);
      this.showShopInfo = shop;
      if (
        this.$vuetify.breakpoint.name !== "xl" &&
        this.$vuetify.breakpoint.name !== "lg"
      ) {
        this.plyr.pause();
      }
      this.hideShopping();
    },
    hideShopping() {
      const hideShop = () => {
        this.showShopInfo = null;
      };
      setTimeout(() => {
        hideShop();
      }, 100000);
    },
    _makeShowCaseMainScene() {},
    _addEventTimeUpdateAndFullScreen(video) {
      const updateAdsPosition = () => {
        const messages = this.getCurrentMetaWithPos() || [];
        let index = 0;
        if (messages.length === 0 || !_.find(messages, { id: 2 })) {
          console.log(
            `Time: ${this.timePlay} | shop: ${
              this.shops.length
            } |  ${new Date().getMinutes()}:${new Date().getSeconds()}`
          );
        }
        for (let oldShop of this.shops) {
          let updateShop = _.find(messages, { id: oldShop.id });
          if (updateShop) {
            // console.log("old shop: ", updateShop);
            const clientW = this.video.clientWidth;
            const clientH = this.video.clientHeight;
            oldShop.x = updateShop.x * clientW;
            oldShop.y = updateShop.y * clientH;
            oldShop.width = updateShop.w * clientW;
            oldShop.height = updateShop.h * clientH;
            oldShop.lineData = this.calLineAnimate(oldShop.textData, oldShop);
            _.remove(messages, { id: oldShop.id });
          } else {
            // console.log("shop destroy: ", oldShop.id);
            this.shops.splice(index, 1);
          }
          index += 1;
        }
        for (const message of messages) {
          const infoShop = _.find(this.showcaseCr.metadata, {
            id: message.id.toString(),
          });
          if (!infoShop) {
            return;
          }
          // console.log("new shop:", message);
          const clientW = this.video.clientWidth;
          const clientH = this.video.clientHeight;
          let x = message.x * clientW;
          let y = message.y * clientH;
          let width = message.w * clientW;
          let height = message.h * clientH;
          let pos = message.pos;
          const textData = this.calculatePosText({
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
          });
          let timeStart = Math.round(new Date().getTime() / 1000);
          if (this.productMarkShowed.includes(infoShop.id)) {
            timeStart = 0;
          } else {
            this.productMarkShowed.push(infoShop.id);
          }
          const newShop = {
            x: x,
            y: y,
            width: width,
            height: height,
            pos: pos,
            textData: textData,
            lineData: this.calLineAnimate(textData, { x: x, y: y, pos: pos }),
            timeStart: timeStart,
            ...infoShop,
          };
          this.shops.push(newShop);
        }
      };
      video.addEventListener("timeupdate", () => {
        if (this.firstTime !== null) {
          this.timePlay =
            this.video.currentTime - this.firstPlay + this.delayHls;
          updateAdsPosition();
        }
      });
      video.addEventListener("fullscreenchange", () => {
        updateAdsPosition();
      });
      return video;
    },
    _parseMetaHls(video) {
      if (Hls.isSupported()) {
        console.log("_parseMetaHls");
        let hls = new Hls();
        hls.attachMedia(video);
        hls.on(Hls.Events.MEDIA_ATTACHED, () => {
          hls.loadSource(this.showcaseCr.url_video);
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            video.play();
          });
          hls.on(Hls.Events.FRAG_CHANGED, (event, data) => {
            if (this.countChange === 1) {
              this.firstTime = data.frag.programDateTime;
              this.firstPlay = this.video.currentTime;
            }
            this.countChange = this.countChange += 1;
            this.currentSegment = data.frag.programDateTime;
          });
        });
      }
      return video;
    },
    _groupMsg(messages) {
      let msg = [];
      for (const data of messages || []) {
        if (data && data.data && data.data.length > 0) {
          for (const item of data.data) {
            if (!_.find(msg, { id: item.id })) {
              const pos = this._detectFixedPosition({
                x: item.x,
                y: item.y,
                width: item.w,
                height: item.h,
              });
              msg.push({
                pos: pos,
                ...item,
              });
            }
          }
        }
      }
      return msg;
    },
    onBuyNow(shop) {
      this.socketMng.emit("click", {
        id: shop.id,
      });
      window.open(shop.url, "_blank");
    },
  },
  mounted() {
    const socket = io(`${process.env.VUE_APP_API_BASE_URL}`, {
      path: "/ws/socket.io",
      transports: ["websocket", "polling"],
      auth: {
        token: process.env.VUE_APP_API_TOKEN,
        live_id: this.showcase_id,
      },
    });
    socket.on("message", (data) => {
      this.handleMsg(data);
    });
    socket.on("click", (data) => {
      console.log("new click", data);
    });
    socket.on("hover", (data) => {
      console.log("new click", data);
    });
    socket.on("comment", (data) => {
      console.log("new click", data);
    });
    this.socketMng = socket;
    console.log("End mounted live");
  },
};
</script>

<style scoped lang="scss">
@import "https://cdn.plyr.io/3.6.7/plyr.css";
@import "../../styles/player.scss";
@import "../../styles/new_tag.scss";
</style>
